export const Ray = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <g>
        <mask
          id="mask0_15650_12633"
          style={{ maskType: 'luminance' }}
          width="48"
          height="48"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <g>
            <path fill="#fff" d="M48 0H0v48h48V0z"></path>
          </g>
        </mask>
        <g mask="url(#mask0_15650_12633)">
          <g>
            <path
              fill="#FB8C00"
              fillRule="evenodd"
              d="M24 0H0l24 24H0l24 24h24L24 24h24L24 0z"
              clipRule="evenodd"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}
